"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcInvocable = exports.readInvocationSettings = void 0;
const BinaryFileDecorator_1 = require("./BinaryFileDecorator");
const INVOCATION_META_SYM = Symbol.for("@leavy/cq/RPC_INVOCABLE_METADATA");
function readInvocationSettings(target) {
    var _a;
    const metadata = target[INVOCATION_META_SYM];
    if (metadata) {
        return {
            ...metadata,
            binaryProperties: (_a = BinaryFileDecorator_1.readBinaryPropertiesMeta(target)) !== null && _a !== void 0 ? _a : undefined,
        };
    }
    return null;
}
exports.readInvocationSettings = readInvocationSettings;
function RpcInvocable(settings) {
    return (target) => {
        const name = `${settings.namespace}.${settings.alias}`;
        target[INVOCATION_META_SYM] = {
            namespace: settings.namespace,
            name,
        };
    };
}
exports.RpcInvocable = RpcInvocable;
//# sourceMappingURL=RpcInvocable.js.map